/**
 * Filters only the first item that matches the predicate and returns the filtered array.
 */
export const filterFirst = <T>(array: T[], predicate: (item: T) => boolean): T[] => {
  let found = false
  return array.filter((item) => {
    if (!found && predicate(item)) {
      found = true
      return false
    }
    return true
  })
}
